import React from 'react';
import { graphql } from 'gatsby';

import SEO from '../components/Seo';
import Layout from '../components/Layout';
import PostPreview from '../components/PostPreview';

const PostList = ({ posts }) => {
	return posts.map(({ node }) => {
		const title = node.frontmatter.title || node.fields.slug;

		// if (process.env.NODE_ENV !== `production` || node.frontmatter.published) {
		return <PostPreview key={node.fields.slug} title={title} node={node} />;
		// }
	});
};

const BlogIndex = ({ data, location }) => {
	const siteTitle = data.site.siteMetadata.title;
	const posts = data.allMdx.edges;

	return (
		<Layout location={location} title={siteTitle}>
			<SEO title="Home" />
			{/* <Bio /> */}
			<PostList posts={posts} />
		</Layout>
	);
};

export default BlogIndex;

export const pageQuery = graphql`
	query {
		site {
			siteMetadata {
				title
			}
		}
		allMdx(
			sort: { fields: [frontmatter___date], order: DESC }
			filter: { frontmatter: { type: { eq: "post" }, published: { eq: true } } }
		) {
			edges {
				node {
					excerpt
					fields {
						slug
					}
					frontmatter {
						date(formatString: "MMMM DD, YYYY")
						title
						description
						published
					}
				}
			}
		}
	}
`;
